import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./order_update_toasts_mode.js";
//#region src/order_update_toasts_mode_helper.ts
var order_update_toasts_mode_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(mode) {
	switch (mode) {
		case "none": return "None";
		case "all-updates": return "All Updates";
		case "scanned-items-and-discounts": return "Scanned Items and Discounts";
		case "discounts-only": return "Discounts Only";
	}
}
//#endregion
export { name, order_update_toasts_mode_helper_exports };

//# sourceMappingURL=order_update_toasts_mode_helper.js.map